<template>
  <div>
    <div class="divButtonRigth" style="margin-bottom: 20px">
        <el-select class="tenant-select" v-show="this.role.tenantId=='sys'" v-model="listQuery.tenantId" @change="_getListpage()">
          <el-option
          v-for="item in tenantList"
          :key="item.tenantId"
          :label="item.name"
          :value="item.tenantId"
          >
          </el-option>
        </el-select>
        <el-button v-show="this.role.tenantId=='sys'" type="primary" size="small" @click="showAddDialog">新增</el-button>
        <el-button type="primary" size="small" @click="initRedisParameter">初始化缓存</el-button>
        <el-button type="primary" size="small" @click="exportTableData">导出</el-button>
    </div>

    <bsp-table
      :data.sync="list"
      ref="sysDataTable"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getListpage()"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <!-- <vxe-table-column type="selection" width="60" fixed="left" align="center" ></vxe-table-column> -->
      <vxe-table-column title="序号" type="index" width="60" fixed="left" align="center"></vxe-table-column>
      <bsp-table-column 
        field="paraKey"
        title="参数key"
        filter-type="input"
      >
        <template
          slot-scope="scope"
        >
          <span>{{ scope.row.paraKey }}</span>
        </template>
      </bsp-table-column>
      <!-- <bsp-table-column
        field="quotePara"
        title="引用参数"
        filter-type="input"
      >
        <template
          slot-scope="scope"
        >
          <span>{{ scope.row.quotePara }}</span>
        </template>
      </bsp-table-column>-->
      <bsp-table-column
        v-show="checkUser"
        field="paraValue"
        title="参数value"
        filter-type="input"
      >
        <template
          slot-scope="scope"
        >
          <span>{{ scope.row.paraValue }}</span>
        </template>
      </bsp-table-column>
      <!-- <bsp-table-column
        field="isMuti"
        title="是否多选"
        filter-type="select"
        set-id="0090"
        multiple="true"
      >
        <template
          slot-scope="scope"
        >
          <span>{{ scope.row.isMuti | dictFilter(dicts) }}</span>
        </template>
      </bsp-table-column>-->
      <bsp-table-column
        field="type"
        title="参数类型"
        filter-type="select"
        :options-list="pType"
      >
        <template
          slot-scope="scope"
        >
          <span>{{ scope.row.type | dictListFilter(pType) }}</span>
        </template>
      </bsp-table-column>
      <!--<bsp-table-column
        field="moduleName"
        title="模块名"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.moduleName }}</span>
        </template>
      </bsp-table-column>-->
      <bsp-table-column
        field="remark"
        title="备注"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        title="操作"
      >
        <template slot-scope="scope">
          <div class="ciic-table-operate">
            <el-button type="text" size="small" @click="showUpdateDialog(scope.row)">
              <i class="el-icon-edit el-icon--right"></i>编辑
            </el-button>
            <!--<el-button size="small" type="success" @click="deleteRow(scope.row)">删除</el-button>-->
          </div>
        </template>
      </bsp-table-column>
    </bsp-table>
    <!--  弹出窗口Dialog -->
    <sys-parameter-dialog
      ref="dialogForm"
      :dialog-status="dialogStatus"
      :list-form="listForm"
      :tab-type="tabType"
      :value-type="pType"
      :dialog-form-visible.sync="dialogFormVisible"
      @data-refresh="_getListpage"
    />
  </div>
</template>
<script>
    import bspTable from "@/components/bsp/bsp-table/bsp-table";
    import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
    import { getListpage, delParameterById, initParameter } from "@/api/sys/parameter";
    import exportMethod from "@/util/export"
    import sysParameterDialog from "@/views/sys/parameter/sys-parameter-dialog";
    import {mapGetters} from 'vuex';

    export default {
      name: "TenantParameterTable",
      components: {bspTable, bspTableColumn, sysParameterDialog },
      props: {
        currentTab: {
          type: String,
          default: ''
        },
      },
      // 渲染前执行的方法
      created() {
        this._getListpage();
      },
      // 渲染后执行的方法
      mounted() {
        this.listQuery.tabType=this.tabType
      },
      // 拿字典值
      computed: {
        ...mapGetters([
          'dicts'
        ])
      },
      watch: {
        currentTab: function(newVal, oldVal) {
          this.tabType = newVal;
          this._getListpage();
        }
      },
      data() {
        return {
          loading: false,
          //用户角色
          role: {    
            tenantId: 'sys',
            name: 'admin'
          },
          dialogFormVisible: false,
          dialogStatus: 'add',
          listForm: {},
          tabType: this.currentTab,
          // tabType: 'sys',
          showTable: false,

          grounpColumns:[
                {
                  field:"paraKey",
                  title:"参数Key",
                  filters:[{data: ''}],
                  filterType:'input',
                  editType:'input'
                },
                {
                  field:"paraValue",
                  title:"参数Value",
                  filters:[{data: ''}],
                  filterType:'input',
                  editType:'input'
            }],
          // 分页请求参数
          listQuery: {
            limit: 20,
            page: 1,
            total: 0,
            tabType: '',
            tenantId: 'sys'
          },

          // 参数类型列表
          pType:[{
              codeItemId: '1',
              codeItemName: '信息项'
            },
            {
              codeItemId: '2',
              codeItemName: '代码'
            },
            {
              codeItemId: '3',
              codeItemName: '文本'
            },
            {
              codeItemId: '4',
              codeItemName: '菜单'
            }],

          list: [],  // 列表对象

          // 租户列表
          tenantList: [
            {
              name: '小红',
              tenantId: '1'
            },
            {
              name: '小黑',
              tenantId: '2'
            }
          ]
        }
      },
      methods: {
        // 获取租户列表
        getTenantList(){
            let tmp=[
                {
                    name: 'admin',
                    tenantId: 'sys'
                },
                {
                    name: '中智财务',
                    tenantId: 2
                }
            ]
            tmp.forEach(value=>{
                this.tenantList.push(value)
            })
        },

        // 增删改----------------------------
        _getListpage() {
          this.dialogFormVisible = false;
          this.listQuery.tabType = this.currentTab;
          //当前用户不是sys时，需要传入自己的tenantId
          if(this.role.tenantId!='sys'){
            this.$set(this.listQuery, 'tenantId', this.role.tenantId)
          }
          this.loading=true
          getListpage(this.listQuery).then(res => {
            this.listQuery.total = res.data.total;
            this.list = res.data.records;
            this.loading=false
          })
        },
        showUpdateDialog(row) {
          this.listForm = row;
          this.dialogFormVisible = true;
          this.dialogStatus = 'update';
        },
        // deleteRow(row) {
        //   delParameterById(row.id).then(res => {
        //     this.$message.success("删除成功！");
        //     this._getListpage();
        //   })
        // },
        showAddDialog() {
          this.listForm = {};
          this.dialogFormVisible = true;
          this.dialogStatus = 'add';
        },
        // ------------------------------------
        initRedisParameter() {
          initParameter().then(res => {
            if (res.data.code !== 2){
              this.$message.success("初始化参数到缓存成功！");
            }
          });
        },
        exportTableData () {
          let obj = {
                columns:this.$refs['sysDataTable'].tableColums,
                ...this.listQuery,
                type: 'excel',
                fileName: '参数表格数据.xls',
                beanName: 'sysParameterServiceImpl',
                methodName: 'queryListPageVO',
                headerRowNum: 2
          };
          exportMethod(obj);
        }
      }
    }

</script>
<style lang="scss">
.tenant-select {
  width: 100px;
  margin: 0px 10px;
}
</style>